import { memo } from 'react';

import { Plus } from '@air/next-icons';
import { Button, type ButtonProps } from '@air/primitive-button';

export type InsertButtonProps = Pick<ButtonProps, 'onClick' | 'disabled'> & {
  count?: number;
};

export const InsertButton = memo(({ count, onClick, disabled }: InsertButtonProps) => (
  <Button
    data-testid="SELECTION_ACTION_BAR_INSERT"
    onClick={onClick}
    disabled={disabled}
    size="small"
    className="ui2:rounded-4"
    prefix={<Plus className="size-4 ui2:size-3" />}
  >
    {count !== undefined ? `Insert ${count}` : 'Insert'}
  </Button>
));

InsertButton.displayName = 'InsertButton';
